export enum LanguageLocale {
  CO = "es_CO",
  MX = "es_MX",
  ZA = "en_ZA",
  BR = "pt_BR",
}
